/* ============
 * Dashboard menu
 * ============
 *
 * This is the header component.
 */

import authService from './../../services/auth';
import accountService from './../../services/account';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      gridData: [{
        date: '2016-05-02',
        summary: 'Lorem Ipsum Dolor',

      }, {
        date: '2016-05-04',
        summary: 'Lorem Ipsum Dolor',

      }, {
        date: '2016-05-01',
        summary: 'Lorem Ipsum Dolor',

      }],
      gridData2: [{
        date: '2016-05-02',
        item: 'Lorem Ipsum Dolor',

      }, {
        date: '2016-05-04',
        item: 'Lorem Ipsum Dolor',

      }, {
        date: '2016-05-01',
        item: 'Lorem Ipsum Dolor',

      }, {
        date: '2016-05-03',
        item: 'Lorem Ipsum Dolor',
      }],
      debugMode: false,
    };
  },

  computed: {
    ...mapGetters({
      account: 'account',
    }),

    organization() {
      return this.account;
    },

    organizations() {
      if (this.account.organizations) {
        const hasMultipleOrganizations = this.account.organizations.filter(o => (
          o.name !== this.organizationName
        ));
        if (hasMultipleOrganizations.length > 0) {
          return hasMultipleOrganizations;
        }
      }
      return false;
    },

    username() {
      return this.organizationName ? `${this.organizationName}` : `${this.name}`;
    },

    organizationName() {
      return this.account.organizationName ? `${this.account.organizationName}` : '';
    },

    name() {
      return (this.account.firstName && this.account.lastName) ? `${this.account.firstName} ${this.account.lastName}` : 
        `${this.account.userFirstName} ${this.account.userLastName}`
      ;
    },

    organizationType() {
      return this.$t(`layouts.header.${this.account.organizationType.toLowerCase()}`);
    },

    email() {
      return this.account.email;
    },

    avatar() {
      const avatar = this.account.organizationProfilePicture;
      if (avatar !== undefined && avatar.url !== undefined) {
        return avatar.url;
      }
      return false;
    },

    /**
     * This computed property will determine if the admin impersonated this account.
     */
    isAdmin() {
      if (localStorage.getItem('is_admin')) {
        return true;
      }

      return false;
    },
  },

  mounted() {
    this.debugMode = this.account.debugMode;
  },

  methods: {
    ...mapMutations({
      toggleSidebar: 'TOGGLE_INNERSIDEBAR',
    }),

    /**
     * This method will logout the user.
     */
    logout() {
      authService.logout();
    },

    /**
     * This method will toggle debug mode.
     */
    toggleDebugMode() {
      this.$confirm(this.$t('static.account.confirmDebugMode'), this.$t('static.account.toggleDebugMode'), {
        confirmButtonText: this.$t('button.yes'),
        cancelButtonText: this.$t('button.no'),
        type: 'warning',
      }).then(() => {
        if (this.debugMode) {
          accountService.onDebugMode(this.account.userId).then(() => {
            this.$message({
              showClose: true,
              message: this.$t('static.account.onDebugMode'),
              type: 'success',
            });
          });
        } else {
          accountService.offDebugMode(this.account.userId).then(() => {
            this.$message({
              showClose: true,
              message: this.$t('static.account.offDebugMode'),
              type: 'success',
            });
          });
        }
      }).catch(() => {
        this.debugMode = !this.debugMode;
      });
    },

    switchOrganization() {
      this.$confirm(this.$t('static.account.confirmSwitchOrganization'), this.$t('static.account.switchOrganization'), {
        confirmButtonText: this.$t('button.yes'),
        cancelButtonText: this.$t('button.no'),
        type: 'warning',
      }).then(() => {
        accountService.switchOrganization(this.account.userId).then(() => {
          this.$message({
            showClose: true,
            message: this.$t('static.account.switchingOrganizationMessage'),
            type: 'success',
          });
        });
      }).catch(() => {
        console.log('error switching organization');
      });
    },

    /**
     * If user has the module.
     */
    hasModule(name) {
      if (this.account.modules) {
        const hasModule = this.account.modules.filter(m => (
          m.name === name
        ));
        if (hasModule.length > 0) {
          return true;
        }
      }
      return false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/header/header.js